import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    { 
      name: 'Priya Sharma', 
      location: 'Mumbai', 
      rating: 4.9, 
      text: 'Thank you for the amazing decoration. It was beautifully done and everyone loved it. Very cooperative and budget-friendly team!' 
    },
    { 
      name: 'Rahul Mehta', 
      location: 'Delhi', 
      rating: 4.8, 
      text: 'I contacted Rahar Decors just a day before my kid\'s birthday and they did an awesome job. Loved the whole decor. Staff were so cooperative and professional.' 
    },
    { 
      name: 'Anjali Patel', 
      location: 'Ahmedabad', 
      rating: 5.0, 
      text: 'Great job done! Extremely professional, reasonable, and great at work. You get what you ask for and little more delights. Looking forward to more work together!' 
    },
    { 
      name: 'Vikram Singh', 
      location: 'Bangalore', 
      rating: 4.7, 
      text: 'Very beautiful decorations! The team was punctual and the setup was exactly as shown. Highly recommend to all families.' 
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="section-title">Trusted Client Reviews</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, idx) => (
            <div key={idx} className="testimonial-card">
              <div className="testimonial-rating">
                {'★'.repeat(Math.floor(testimonial.rating))}
                <span className="rating-number">({testimonial.rating})</span>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.name[0]}</div>
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>📍 {testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
